import React from 'react';

import Container from './Container';
import Image from './Image';
import Details from './Details';

export default ({ item, address, size }) => (
  <Container>
    <Image src={item.primary_image} />
    <Details address={address} title={item.title} price={item.price} login={item.seller.login} size={size} />
  </Container>
);
